const dateTime = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'medium',
  timeStyle: 'short',
});
const count = new Intl.NumberFormat(undefined);

/** Locale-aware date and time. Invalid input is returned as given. */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return dateTime.format(date);
}

/** Locale-aware integer. */
export function formatCount(n: number): string {
  return count.format(n);
}
